import React, { useEffect } from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { useDispatch } from 'react-redux'
import { useQuery } from '@apollo/react-hooks'
import Header from '../Header'
import Map from '../Map'
import TabbedTable from '../TabbedTable'
import { useSelector } from 'react-redux'
import { GET_PROJECTS } from '../../queries/project'
import { loadProjects } from '../../actions'
import Home from '../Home'
import ProjectDialog from '../ProjectDialog'
import ScenarioDialog from '../ScenarioDialog'

const theme = createTheme({
  palette: {
    primary: {
      main: '#333',
    },
  },
  spacing: 4,
})

function PageWrapper(props) {
  const style = {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  }

  return <div style={{ style }}>{props.children}</div>
}

function Loader() {
  const loaderStyle = {
    display: 'flex',
    height: '200px',
    width: '100%',
  }

  return (
    <>
      <div style={loaderStyle}>
        <div className="loading" />
      </div>
    </>
  )
}

function App() {
  const dispatch = useDispatch()
  const { selectedProjectId, selectedScenarioId, remoteStorage } = useSelector(
    state => state
  )

  let loading, data

  if (remoteStorage.projects) {
    const result = useQuery(GET_PROJECTS)
    loading = result.loading
    data = result.data
    useEffect(() => {
      if (data) {
        dispatch(loadProjects(data.projects))
      }
    }, [data])

    if (loading || data === undefined) {
      return <Loader />
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <Header />
        <Home />
        {selectedProjectId !== null ? <Map /> : <div />}
        {selectedScenarioId !== null ? <TabbedTable /> : <></>}
        <ProjectDialog />
        <ScenarioDialog />
      </PageWrapper>
    </ThemeProvider>
  )
}

export default App
